export interface IMediaItem {
  $element: JQuery<HTMLElement>
  idx:number
  title: string,
  title_url: string,
  period_item_url: string,
  channel: string,
  date: string,
  time: string,
  metadata?:string,
  path: string,
  pathVariants: string[][],
  currentQuality: number,
  description: string,
  picture: string,
  playListNextItem: number
  periodItemIndex: number,
  autoplayExcluded: boolean
}

export type IMediaList = Array<IMediaItem>

export enum PlayerTypes {
  ADD_LIST,
  PLAY,
  PAUSE,
  NEXT_SONG,
  PREV_SONG,
  NEXT_JOINED_SONG
}

interface IPlayAction {
  type: typeof PlayerTypes.PLAY
  list: IMediaList
  current: IMediaItem
  listID: number
}

interface IPauseAction {
  type: typeof PlayerTypes.PAUSE
}

interface INextSongAction {
  type: typeof PlayerTypes.NEXT_SONG
}

interface INextJoinedSongAction {
  type: typeof PlayerTypes.NEXT_JOINED_SONG
}

interface IPrevSongAction {
  type: typeof PlayerTypes.PREV_SONG
}

export type PlayerActions =
  | IPlayAction
  | IPauseAction
  | INextSongAction
  | INextJoinedSongAction
  | IPrevSongAction
